import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';

import {
  selectCatalogEbikesPinnedFilters,
  togglePinnedFiltersState,
} from '@store';
import { useHasFilters } from 'hooks/common';

export const useEbikesFilterConfig = ({ enums }) => {
  const router = useRouter();
  const pinnedFilters = useSelector(selectCatalogEbikesPinnedFilters);
  const dispatch = useDispatch();

  const { brandOptions, categoryOptions, statusOptions } = enums;

  const filterCategories = useMemo(
    () => [
      {
        id: 'brand',
        label: 'Brand',
        icon: PanoramaFishEyeIcon,
        options: brandOptions,
        multiSelect: false,
      },
      {
        id: 'category',
        label: 'Category',
        icon: PanoramaFishEyeIcon,
        options: categoryOptions,
        multiSelect: false,
      },
      {
        id: 'status',
        label: 'Status',
        icon: PanoramaFishEyeIcon,
        options: statusOptions,
        multiSelect: false,
      },
    ],
    [brandOptions, categoryOptions, statusOptions]
  );
  const { hasFilters } = useHasFilters({ pinnedFilters });

  const currentFilters = useMemo(() => {
    const parseQueryValue = (value) => {
      if (!value) return [];
      if (typeof value === 'string') {
        return value.split(',').filter(Boolean);
      }
      return Array.isArray(value) ? value : [];
    };

    return {
      brand: parseQueryValue(router.query.brand),
      category: parseQueryValue(router.query.category),
      status: parseQueryValue(router.query.status),
    };
  }, [router.query]);

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(
      togglePinnedFiltersState({ board: 'catalogEbikes', pinnedFilter })
    );
  };

  return {
    filterCategories,
    currentFilters,
    pinnedFilters,
    supportPinnedFilters: true,
    hasFilters,
    handlePinnedFilterSelect,
  };
};
